import { useLocation } from 'react-router-dom';
import { useLang } from '@/lib/LanguageContext';
import { LOCALES, LIVE_LOCALES } from '@/lib/locales';
import { buildWhatsAppLink } from '@/components/services/servicesData';

// Instant Spanish for the most-used default messages (others go through t()).
const FIXED_ES = {
  "Hi Jotunheims! I'd like to get more information about your services and how you can help my business.":
    '¡Hola, Jotunheims! Me gustaría recibir más información sobre sus servicios y cómo pueden ayudar a mi negocio.',
  "Hi Jotunheims! I'm interested in your services and would like more information.":
    '¡Hola, Jotunheims! Estoy interesado en sus servicios y me gustaría recibir más información.'
};

// Builds WhatsApp links whose pre-filled text follows the visitor's language and country hub.
export default function useWhatsApp() {
  const { t, language } = useLang();
  const { pathname } = useLocation();
  const cc = pathname.split('/')[1];
  const loc = LIVE_LOCALES.includes(cc) ? LOCALES[cc] : null;

  const lang = loc?.lang || language;

  const text = (msg) => {
    let out = lang === 'es' ? (FIXED_ES[msg] || t(msg)) : msg;
    if (loc && !/desde|from /i.test(out)) {
      out += lang === 'es' ? ` (Les escribo desde ${loc.label}.)` : ` (Contacting you from ${loc.country}.)`;
    }
    return out;
  };

  return { waLink: (msg) => buildWhatsAppLink(text(msg)), waText: text, t };
}